import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, Outlet, useLocation } from "react-router-dom";
import { LangProvider } from "@/context/LangContext";
import { AuthProvider } from "@/context/AuthContext";
import { StaffAuthProvider } from "@/context/StaffAuthContext";
import Header from "@/components/Header";
import Footer from "@/components/Footer";
import HomePage from "@/pages/HomePage";
import LoginPage from "@/pages/LoginPage";
import RegisterPage from "@/pages/RegisterPage";
import ForgotPasswordPage from "@/pages/ForgotPasswordPage";
import ResetPasswordPage from "@/pages/ResetPasswordPage";
import AdminPage from "@/pages/AdminPage";
import PortalPage from "@/pages/PortalPage";
import StaffLoginPage from "@/pages/StaffLoginPage";
import StaffPage from "@/pages/StaffPage";
import { Toaster } from "sonner";

function Layout() {
  const loc = useLocation();
  const hideChrome = loc.pathname === "/login" || loc.pathname === "/register" || loc.pathname === "/forgot-password" || loc.pathname === "/reset-password" || loc.pathname === "/staff/login";
  return (
    <div className="App min-h-screen flex flex-col">
      <Header />
      <div className="flex-1">
        <Outlet />
      </div>
      {!hideChrome && <Footer />}
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <AuthProvider>
        <StaffAuthProvider>
          <BrowserRouter>
          <Routes>
            <Route element={<Layout />}>
              <Route path="/" element={<HomePage />} />
              <Route path="/login" element={<LoginPage />} />
              <Route path="/register" element={<RegisterPage />} />
              <Route path="/forgot-password" element={<ForgotPasswordPage />} />
              <Route path="/reset-password" element={<ResetPasswordPage />} />
              <Route path="/portal" element={<PortalPage />} />
              <Route path="/admin" element={<AdminPage />} />
              <Route path="/staff/login" element={<StaffLoginPage />} />
              <Route path="/staff" element={<StaffPage />} />
              <Route path="*" element={<HomePage />} />
            </Route>
          </Routes>
        </BrowserRouter>
        <Toaster richColors position="top-center" />
        </StaffAuthProvider>
      </AuthProvider>
    </LangProvider>
  );
}

export default App;
